<script>
import ButtonAll from '../UI/Button/ButtonAll.vue'
import ModalConfirmation from '../UI/Modal/ModalConfirmation.vue'
import CommentForm from './CommentForm.vue'
import mixinComponent from '../../Mixins/mixinComponent'
import { globalMethodsMixin, globalVariablesMixin } from '../../Mixins/global'

export default {
  components: { CommentForm, ModalConfirmation, ButtonAll },
  mixins: [mixinComponent, globalVariablesMixin, globalMethodsMixin],

  props: {
    context: { type: String, required: true },
    contextId: { type: String, required: true },
  },

  data() {
    return {
      comments: [],
      params: {},
    }
  },

  methods: {
    getComments() {
      this.getJSON('comments?context=' + this.context + '&contextId=' + this.contextId).then((json) => {
        this.comments = json
        this.params = { context: this.context, contextId: this.contextId }
      })
    },
    showModal(id = null) {
      if (id) {
        this.$refs['commentform' + id][0].showForm()
      } else {
        this.$refs.commentform.showForm()
      }
    },
    reloadData(datas) {
      let commentIndex = this.comments.findIndex((c) => c.id === datas.json.id)
      if (datas.method != 'delete') {
        if (commentIndex == -1) {
          this.comments.push(datas.json)
        } else {
          this.comments.splice(commentIndex, 1, datas.json)
        }
      } else {
        this.comments.splice(commentIndex, 1)
      }
    },
    showDelete(id) {
      this.$refs['modalconfirmation' + id][0].showModal()
    },
    deleteComment(id) {
      this.deleteJSON('comments/' + id, { context: this.context, contextId: this.contextId }, {}).then(
        (json) => {
          this.$refs['modalconfirmation' + id][0].closeModal()
          this.getComments()
        },
        (reason) => {},
      )
    },
  },

  updated() {
    $('#' + this.contextId).click(function () {
      $(this).find('i').toggleClass('fas fa-plus fas fa-minus')
    })
  },

  beforeMount() {
    this.getComments()
  },
}
</script>
<template>
  <div class="container">
    <div v-if="!user.isReadOnly" class="row p-2">
      <div class="col-xl-9 col py-1">
        <ButtonAll margin="no" type="validation" @click="showModal(null)" label="comment.add" name="commentAdd" />
      </div>
      <div class="col-xl-3 col d-flex py-1">
        <div class="bg-info perfect-cercle" e2e-data="commentCount">{{ comments.length }}</div>
        <button
          type="button"
          v-if="comments.length > 0"
          :id="contextId"
          class="btn card-header"
          data-toggle="collapse"
          :data-target="'#mycomments' + contextId"
          e2e-button="toggleComments"
        >
          <i class="fa fa-plus" />
        </button>
      </div>
    </div>
    <div v-if="comments.length > 0" :id="'mycomments' + contextId">
      <div v-for="comment in comments" :key="comment.id" :e2e-row="'comment-' + comment.id">
        <ModalConfirmation
          :ref="'modalconfirmation' + comment.id"
          :id="String(comment.id)"
          :param="String(comment.id)"
          title="comment.delete.title"
          @confirm="deleteComment"
        />

        <table class="table table-striped table-bordered fs-16">
          <tbody>
            <tr>
              <td class="d-flex justify-content-between">
                <div>
                  <div>
                    {{ $t('comment.created.at') + setDate(comment.createdAt, 'datetime') }} |
                    {{ $t('comment.created.by') }} {{ comment.createdBy ? comment.createdBy.name : '' }}
                  </div>
                  <div v-if="comment.modifiedAt">
                    {{ $t('comment.modified.at') + setDate(comment.modifiedAt, 'datetime') }} |
                    {{ $t('comment.modified.by') }} {{ comment.modifiedBy ? comment.modifiedBy.name : '' }}
                  </div>
                </div>
                <div v-if="!user.isReadOnly" class="d-flex">
                  <div style="cursor: pointer" e2e-button="commentUpdate">
                    <i class="fas fa-edit" @click.stop="showModal(comment.id)"></i>
                    <CommentForm
                      :ref="'commentform' + comment.id"
                      :params="params"
                      :comment-id="comment.id"
                      method="patch"
                      @comment-sent="reloadData"
                    />
                  </div>
                  <div
                    v-if="user.name == comment.createdBy.name"
                    class="ml-2"
                    style="cursor: pointer"
                    @click="showDelete(comment.id)"
                    e2e-button="commentDelete"
                  >
                    <i class="fas fa-times" />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td v-html="comment.comment" e2e-data="commentContent" />
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <CommentForm v-if="!user.isReadOnly" ref="commentform" :params="params" @comment-sent="reloadData" />
  </div>
</template>
